import { render, staticRenderFns } from "./ExpensesCard.vue?vue&type=template&id=098f8357&scoped=true&"
import script from "./ExpensesCard.vue?vue&type=script&lang=js&"
export * from "./ExpensesCard.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesCard.vue?vue&type=style&index=0&id=098f8357&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098f8357",
  null
  
)

export default component.exports